export const createYandexMapLink = (city: string, street: string) => encodeURI(`https://yandex.ru/maps?mode=search&text=${city} ${street}`);
